export const messages = {
  en: {
    refundDepositFee: {
      title: 'Refund Deposit',
      unrefunded: 'Unrefunded',
      refunded: 'Refunded',
      pendingReview: 'Pending Review',
      printReceipt: 'Reprint Receipt',
      alertText: 'Are you sure you want to refund the deposit?',
      page: {
        subtitle: 'Review and refund the deposit fees collected for this owner',
        empty: 'No deposit fee records found',
        loadFailed: 'Failed to load deposit fee records, please retry',
        tip: 'Switch the status on the left to view refunds in different stages.'
      }
    },
    payFeeDeposit: {
      payerObject: 'Payer',
      feeItem: 'Fee Item',
      timePeriod: 'Time Period',
      amount: 'Amount',
      paymentTime: 'Payment Time',
      status: 'Status',
      operation: 'Operation',
      refundDeposit: 'Refund Deposit',
      detail: 'Detail',
      title: 'Deposit Information',
      depositInfo: 'Deposit Information',
      refresh: 'Refresh',
      payerObj: 'Payer Object',
      feeName: 'Fee Item',
      timeRange: 'Time Range',
      refund: 'Refund'
    },
    returnPayFee: {
      fillRefundReason: 'Fill Refund Reason',
      payment: 'Payment',
      monthUnit: '(Months)',
      cycle: 'Cycle',
      receivableAmount: 'Receivable Amount',
      receivedAmount: 'Received Amount',
      paymentTime: 'Payment Time',
      refundReason: 'Refund Reason',
      reasonRequired: 'Refund reason is required',
      reasonMaxLength: 'Refund reason cannot exceed 200 characters',
      reasonPlaceholder: 'Please enter refund reason',
      submitRefund: 'Submit Refund Application'
    }
  },
  zh: {
    refundDepositFee: {
      title: '退押金',
      unrefunded: '未退押金',
      refunded: '已退押金',
      pendingReview: '待审核',
      printReceipt: '补打退款单',
      alertText: '押金退款后自动存到账户中，您可以从账户中选择缴费，如果退现金给业主，请到业务首页面退押金！',
      page: {
        subtitle: '查看并办理该业主的押金退费',
        empty: '暂无押金费用记录',
        loadFailed: '押金费用记录加载失败，请重试',
        tip: '切换左侧状态可查看不同阶段的退费记录。'
      }
    },
    payFeeDeposit: {
      payerObject: '收费对象',
      feeItem: '费用项',
      timePeriod: '时间段',
      amount: '金额',
      paymentTime: '缴费时间',
      status: '状态',
      operation: '操作',
      refundDeposit: '退押金',
      detail: '详情',
      title: '押金信息',
      depositInfo: '押金信息',
      refresh: '刷新',
      payerObj: '收费对象',
      feeName: '费用项',
      timeRange: '时间段',
      // amount: '金额',
      // paymentTime: '缴费时间',
      // operation: '操作',
      refund: '退押金'
    },
    returnPayFee: {
      fillRefundReason: '填写退费原因',
      payment: '缴费',
      monthUnit: '(单位月)',
      cycle: '周期',
      receivableAmount: '应收金额',
      receivedAmount: '实收金额',
      paymentTime: '缴费时间',
      refundReason: '退费原因',
      reasonRequired: '退费原因不能为空',
      reasonMaxLength: '退费原因不能超过200个字符',
      reasonPlaceholder: '请输入退费原因',
      submitRefund: '提交退费申请'
    }
  }
}